import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ILocation} from '../../../../shared/view-model/ilocation.interface';
import {AbstractVisbosComponent} from '../../../../core/visbos-core/components/abstract-visbos.component';
import {SessionActions} from '../../../../shared/actions';
import {MessageType} from '../../../../shared/redux-store/session';
import {AssetService} from '../../services/asset.service';
import {RfidService} from '../../../../identity/services/rfid.service';
import {Identifiable} from '../../../../identity/model/identifiable.interface';
import {Depot} from '../../../../shared/view-model/store-management/depot.type';
import {Observable, Observer} from 'rxjs';
import {map, switchMap, tap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';

@Component({
  selector: 'vb-location-selection',
  templateUrl: './location-selection.component.html',
  styleUrls: ['./location-selection.component.css']
})
export class LocationSelectionComponent extends AbstractVisbosComponent implements OnInit {


  selectedLocationLabel: string;

  suggestions$: Observable<ILocation[]>;
  locationsLoading: boolean;

  private _location: ILocation;

  @Output()
  locationChange: EventEmitter<ILocation> = new EventEmitter<ILocation>();

  get location(): ILocation {
    return this._location;
  }

  @Input()
  set location(value: ILocation) {
    this._location = value;
  }

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private assetService: AssetService, private rfidService: RfidService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
    this.suggestions$ = new Observable((observer: Observer<string>) => {
      observer.next(this.selectedLocationLabel);
    }).pipe(
      switchMap((query: string) => {
        if (query) {
          this.locationsLoading = true;
          return this.assetService.fetchLocationsOnce({
            query: query
          }).pipe(
            tap(res => {
              this.locationsLoading = res.loading;
            }, err => {
              // in case of http error
              this.sessionActions.throwError(err, "Fehler beim Abrufen der Standorte");
              this.locationsLoading = false;
            }),
            map(res => res && res.data.locations || [])
          );
        } else {
          return of([]);
        }
      })
    );
  }

  public resolveEPCs(epcs: string[]) {

    if (!epcs || !epcs.length) {
      this.sessionActions.pushMessage("Es wurden keine EPC-Tags erkannt, bitte versuchen Sie es noch einmal!", MessageType.WARNING, "Standort-Auswahl");
      return;
    }

    if (epcs.length > 1) {
      this.sessionActions.pushMessage("Es wurden mehrere EPC-Tags im Lesefeld erkannt, bitte entfernen Sie überzählige RFID-Tags aus dem Lesefeld und versuchen Sie es noch einmal!", MessageType.WARNING, "Standort-Auswahl");
      return;
    }

    const locationQuery$ = this.rfidService.resolveEPCsOnce({
      epcs: epcs,
      includeChildren: false
    });

    locationQuery$.subscribe(res => {
      this.processResult(res.data.itemsByEPCs[0]);
    }, err => {
      this.sessionActions.throwError(err, "Fehler beim Auflösen des EPC-Codes!");
    }, () => {
      console.info("Completed query");
    });
  }

  private processResult(item: Identifiable) {
    if (item.__typename != 'Depot' && item.__typename != 'DepotYard') {
      this.sessionActions.pushMessage("Der erfasste RFID-Tag referenziert keinen gültigen Standort!", MessageType.WARNING, "Standort-Auswahl");
      return;
    }

    this.onLocationSelected(item);
  }

  public onLocationSelected(location: ILocation) {
    this.location = location;
    this.selectedLocationLabel = null;
    this.locationChange.emit(location);
  }

  public deselectLocation() {
    this.onLocationSelected(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/components/location-selection/location-selection.component.ts